// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"j1-z"};